import { useEffect, useState } from "react";

const useCountdown = (target) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, (target || 0) - now);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    mins: Math.floor(diff / 60000) % 60,
    secs: Math.floor(diff / 1000) % 60,
  };
};

const UNITS = [["days", "Days"], ["hours", "Hours"], ["mins", "Mins"], ["secs", "Secs"]];

export const Countdown = ({ target, size = "lg", testid = "countdown" }) => {
  const ms = target ? new Date(target).getTime() : 0;
  const t = useCountdown(ms);
  const big = size === "lg";
  return (
    <div className={`flex ${big ? "gap-6 sm:gap-12" : "gap-5"}`} data-testid={testid} data-target={target || ""} role="timer" aria-live="off">
      {UNITS.map(([k, l]) => (
        <div key={k}>
          <div className={`display tabular-nums ${big ? "text-[clamp(3.5rem,9vw,8.5rem)]" : "text-4xl"}`} data-testid={`${testid}-${k}`}>
            {String(t[k]).padStart(2, "0")}
          </div>
          <div className={`label text-ink/60 ${big ? "mt-3" : "mt-1 !text-[9px]"}`}>{l}</div>
        </div>
      ))}
    </div>
  );
};
